import { render, staticRenderFns } from "./imageUploader.vue?vue&type=template&id=64cb2b24&scoped=true&"
import script from "./imageUploader.vue?vue&type=script&lang=js&"
export * from "./imageUploader.vue?vue&type=script&lang=js&"
import style0 from "./imageUploader.vue?vue&type=style&index=0&id=64cb2b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb2b24",
  null
  
)

export default component.exports